import React from 'react'
import Nav from 'component/Nav'
import Sticky from 'react-sticky-el'
// import { Topbar } from 'component/Topbar'
import { Topbar } from 'component/Topbar/TopbarLawyerMonth'

export function Header({ showTopbar }) {
	return (
		<div className="page_header_container">
			<Sticky className="header_wrapper" stickyClassName="header header-sticky">
				{showTopbar && (
					// <Topbar
					// 	message="Menos esforço. Mais resultados. Simplifique sua rotina com inteligência."
					// 	link="/experimente-o-astrea/"
					// 	messageBtn="Começar grátis"
					// 	messageBtnMobile="Quero experimentar"
					// />
					<Topbar
						message="Escolha mudar o seu futuro. São apenas 200 cupons."
						link="/experimente-o-astrea/"
						messageBtn="Aproveitar desconto"
						messageBtnMobile="Aproveitar desconto"
					/>
				)}

				<header className={`header_inner`}>
					<Nav />
				</header>
			</Sticky>
		</div>
	)
}
